import { useCollections } from "utils/requests";
import { Landing } from "./Landing.index";

const LandingPage = () => {
  const { data: collections } = useCollections();

  return <Landing name="Home" collections={collections?.collections} />;
};

export default LandingPage;
